import axios from "@axios";
import set from "lodash.set";
import unset from "lodash.unset";
import get from "lodash.get";

import { jsonToGraphQLQuery } from "json-to-graphql-query";

export default {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
    queryFilters: {},
    reportQuery: {},
    filtersSchema: {},
    savedFields: [],
    savedFilters: {},
    page: 1,
    size: 10,
    sizeOptions: [
      10, 25, 50, 100, 'كل السجلات'
      // , { value: "MAX", text: "كل السجلات" }
    ],
  },
  getters: {
    queryFilters(state) {
      return state.queryFilters;
    },
    loading(state) {
      return state.loading;
    },
    saving(state) {
      return state.saving;
    },
    reportQuery(state) {
      return state.reportQuery;
    },
    filtersSchema(state) {
      return state.filtersSchema;
    },
    sizeOptions(state) {
      return state.sizeOptions;
    },
    page(state) {
      return state.page;
    },
    size(state) {
      return state.size;
    },
    savedFields(state) {
      return state.savedFields.map((e) => {
        return { key: e };
      });
    },
    savedFilters(state) {
      return state.savedFilters;
    },
  },
  mutations: {
    setFilter(state, payload) {
      state.filtersSchema[payload.path] = payload.value;
      state.filtersSchema[payload.path].attrs.label = payload.label;
    },
    clearFilterSchema(state) {
      state.filtersSchema = {};
      state.queryFilters = {};
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setSize(state, payload) {
      state.size = payload;
    },
    setPage(state, payload) {
      state.page = payload;
    },
    setSaving(state, payload) {
      state.saving = payload;
    },
    setSavedFields(state, payload) {
      state.savedFields = payload;
    },
    pushField(state, payload) {
      state.savedFields.push(payload);
    },
    removeField(state, payload) {
      var indexToDelete = state.savedFields.indexOf(payload);
      state.savedFields.splice(indexToDelete, 1);
    },

    unsetFilter(state, { path, key }) {
      delete state.filtersSchema[`${path}.${key}`];
    },
    setQuery(state, payload) {
      set(state.reportQuery, payload.path, payload.value);
    },
    clearQuery(state) {
      state.reportQuery = {};
      state.savedFields = [];
    },
    unsetQuery(state, { path, key }) {
      if (get(state.reportQuery, `${path}.${key}`))
        unset(state.reportQuery, `${path}.${key}`);
      if (get(state.reportQuery, path)) {
        if (Object.keys(get(state.reportQuery, path)).length === 0)
          unset(state.reportQuery, path);
      }
    },

    setQueryFilters(state, payload) {
      set(state.queryFilters, payload.path, payload.value);
    },

    unsetQueryFilters(state, { path, key }) {
      unset(state.queryFilters, `${path}.${key}`);
      if (Object.keys(get(state.queryFilters, path)).length === 0)
        unset(state.queryFilters, path);
    },
  },
  actions: {
    async saveReport({ commit, state }, name) {
      commit("setSaving", true);
      await axios
        .post("v2/ministry/report-histories", {
          name: name,
          query: jsonToGraphQLQuery(state.reportQuery),
        })
        .then((res) => {
          return Promise.resolve();
        })
        .catch((err) => {})
        .finally(() => {
          commit("setSaving", false);
        });
    },
  },
};
